<div class='content flex-column justify-center align-center'>
  <div class='profile-form flex-column'>
    <h3 class='section-label'>{{ 'complete-profile.gradeLevelLabel' | translate }}</h3>
    <div class='toggle-grid three-col'>
      @for (level of gradeLevelOptions; track level.key) {
        <button mat-button
                class='toggle-btn'
                data-testid='grade-level-{{level.key}}'
                [class.secondary-action]='!isGradeLevelSelected(level.key)'
                [class.primary-action]='isGradeLevelSelected(level.key)'
                (click)='toggleGradeLevel(level.key)'>
          {{ level.label | translate }}
          @if (isGradeLevelSelected(level.key)) {
            <mat-icon class='check-icon lt-md:hide'
                             svgIcon='check_circle'></mat-icon>
          }
        </button>
      }
    </div>

    <h3 class='section-label'>{{ 'complete-profile.subjectLabel' | translate }}</h3>
    <div class='toggle-grid three-col'>
      @for (subject of subjectOptions; track subject.key) {
        <button mat-button
                class='toggle-btn'
                data-testid='subject-{{subject.key}}'
                [class.secondary-action]='!isSubjectSelected(subject.key)'
                [class.primary-action]='isSubjectSelected(subject.key)'
                (click)='toggleSubject(subject.key)'>
          {{ subject.label | translate }}
          @if (isSubjectSelected(subject.key)) {
            <mat-icon class='check-icon lt-md:hide'
                             svgIcon='check_circle'></mat-icon>
          }
        </button>
      }
    </div>
    <p class='section-hint'>{{ 'complete-profile.subjectHint' | translate }}</p>
  </div>
</div>
